import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Button from '../components/ui/Button';

const Terms: React.FC = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto glass-card p-8">
          <h1 className="text-3xl font-bold mb-8 bg-gradient-to-r from-primary to-accent text-transparent bg-clip-text">
            Terms and Conditions
          </h1>
          
          <div className="space-y-6 text-text/90">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
              <p className="mb-3">
                Welcome to Matrix Finance. These Terms and Conditions govern your use of our website and services. 
                By accessing or using Matrix Finance, you agree to be bound by these Terms.
              </p>
              <p>
                Matrix Finance provides financial guidance, tips, and communication with financial experts. 
                Our service is intended to provide general information and not specific investment advice.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">2. Definitions</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>"Platform" refers to the Matrix Finance website and services.</li>
                <li>"User", "You", and "Your" refers to the individual accessing or using the Platform.</li>
                <li>"We", "Us", and "Our" refers to Matrix Finance.</li>
                <li>"Content" refers to information, text, graphics, or other materials on the Platform.</li>
                <li>"Financial Expert" refers to individuals providing guidance through our Platform.</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">3. Account Registration</h2>
              <p className="mb-3">
                To access certain features of the Platform, you must register for an account. You agree to provide accurate,
                current, and complete information during the registration process and to update such information to keep it
                accurate, current, and complete.
              </p>
              <p>
                You are responsible for safeguarding your password and for all activities that occur under your account. 
                You agree to notify us immediately of any unauthorized use of your account.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">4. Financial Advice Disclaimer</h2>
              <p className="mb-3">
                The financial information provided on Matrix Finance is for educational and informational purposes only. 
                It is not intended to be, and should not be construed as, financial, investment, tax, or legal advice.
              </p>
              <p className="mb-3">
                While our Financial Experts strive to provide accurate and helpful information, their guidance is general 
                in nature and may not be suitable for your specific financial situation. Always consult with a qualified 
                financial professional before making investment decisions.
              </p>
              <p>
                Matrix Finance is not responsible for any financial decisions made based on the information provided 
                through our Platform.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">5. User Conduct</h2>
              <p className="mb-2">You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Use the Platform in any way that violates any applicable laws or regulations.</li>
                <li>Impersonate any person or entity or falsely state or misrepresent your affiliation with a person or entity.</li>
                <li>Interfere with or disrupt the Platform or servers or networks connected to the Platform.</li>
                <li>Harvest or collect user information, including email addresses, without their consent.</li>
                <li>Use the Platform to send unsolicited emails or messages.</li>
                <li>Attempt to gain unauthorized access to any portion of the Platform.</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">6. Intellectual Property</h2>
              <p className="mb-3">
                The Platform and its original content, features, and functionality are owned by Matrix Finance and are protected 
                by international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
              <p>
                You may not modify, reproduce, distribute, create derivative works or adaptations of, publicly display or in 
                any way exploit any of the content in whole or in part except as expressly authorized by us.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">7. Privacy</h2>
              <p>
                Our Privacy Policy, which is incorporated into these Terms by reference, describes how we collect, use, and share 
                your personal information. By using Matrix Finance, you agree to our collection, use, and sharing of your 
                information as described in our Privacy Policy.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">8. Limitation of Liability</h2>
              <p className="mb-3">
                To the maximum extent permitted by law, Matrix Finance shall not be liable for any indirect, incidental, special, 
                consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, 
                or any loss of data, use, goodwill, or other intangible losses.
              </p>
              <p>
                In no event shall our aggregate liability exceed the amount you paid, if any, for using our Platform during the 
                twelve (12) month period immediately preceding the date of the claim.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">9. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. We will provide notice of significant changes by posting 
                the updated Terms on the Platform. Your continued use of the Platform after such changes constitutes your acceptance 
                of the new Terms.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">10. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of [Jurisdiction], without regard to 
                its conflict of law provisions.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">11. Contact Us</h2>
              <p>
                If you have any questions about these Terms, please contact us at support@matrixfinance.com.
              </p>
            </section>
            
            <div className="pt-6 border-t border-border">
              <p className="mb-4">
                By using Matrix Finance, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
              </p>
              
              <div className="flex justify-between items-center">
                <p className="text-sm text-text/50">Last updated: June 15, 2023</p>
                <Link to="/">
                  <Button>Back to Home</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Terms; 